import { Routes } from '@angular/router';
import { authGuardAllow, authGuardDeny } from './guards/auth.guard';
import { VariableComponent } from './components/variables/variables.component';
import { AppMainComponent } from './components/layout/main/main.component';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'console'
    },
    {
        path: 'login',
        loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
        canActivate: [authGuardAllow]
    },
    {
        path: 'register',
        loadComponent: () => import('./components/register-via-contact-us/register-via-contact-us.component').then(m => m.RegisterViaContactUsComponent),
        canActivate: [authGuardAllow]
    },
    {
        path: 'registernew',
        loadComponent: () => import('./components/register/register.component').then(m => m.RegisterComponent),
        canActivate: [authGuardAllow]
    },
    // The console is the app: signing in lands here. The classic screens below stay reachable
    // (/projects/list and the per-service routes) for what the console doesn't cover yet.
    {
        path: 'console',
        pathMatch: 'full',
        loadComponent: () => import('./console/home/console-home.component').then(m => m.ConsoleHomeComponent),
        canActivate: [authGuardDeny]
    },
    {
        path: 'console/connect/:project',
        loadComponent: () => import('./console/connect/connect-wizard.component').then(m => m.ConnectWizardComponent),
        canActivate: [authGuardDeny]
    },
    {
        path: 'console/:project/:env',
        loadComponent: () => import('./console/shell/console-shell.component').then(m => m.ConsoleShellComponent),
        canActivate: [authGuardDeny]
    },
    {
        path: 'eruauth/:project_id/:env_id',
        component: AppMainComponent,
        canActivate: [authGuardDeny],
        children: [
            {
                path: '',
                loadComponent: () => import('./components/eruauth/eruauth-main/eruauth-main.component').then(m => m.EruauthMainComponent)
            },
            {
                path: 'authorizers',
                loadComponent: () => import('./components/eruauth/eruauth-list/eruauth-list.component').then(m => m.EruauthListComponent)
            },
            {
                path: 'authorizers/new',
                loadComponent: () => import('./components/eruauth/eruauth-form/eruauth-form.component').then(m => m.EruauthFormComponent)
            },
            {
                path: 'authorizers/edit/:authorizer_name',
                loadComponent: () => import('./components/eruauth/eruauth-form/eruauth-form.component').then(m => m.EruauthFormComponent)
            },
            {
                path:'settings',
                loadComponent:()=>import('./components/settings/settings-main/settings-component').then(m=>m.ProjectSettingsComponent)
            },
            {
                path:'settings/new-kms',
                loadComponent:()=>import('./components/settings/kms-form/kms-form.component').then(m=>m.KmsFormComponent)
            },
            {  
                path:'settings/edit-kms/:kms_name',
                loadComponent:()=>import('./components/settings/kms-form/kms-form.component').then(m=>m.KmsFormComponent)
            },
            {
                path:'settings/new-event',
                loadComponent:()=>import('./components/settings/event-form/event-form.component').then(m=>m.EventFormComponent)
            },
            {
                path:'settings/edit-event/:event_name',
                loadComponent:()=>import('./components/settings/event-form/event-form.component').then(m=>m.EventFormComponent)
            }, 
            {
                path: 'variables',
                loadComponent: () => import('./components/variables/variables.component').then(m => m.VariableComponent)
            }
        ]
    },
    {
        path: 'eruai/:project_id/:env_id',
        component: AppMainComponent,
        canActivate: [authGuardDeny],
        children: [
            {
                path: '',
                loadComponent: () => import('./components/eruai/eruai-main/eruai-main.component').then(m => m.EruaiMainComponent)
            },
            {
                path: 'tenants',
                loadComponent: () => import('./components/eruai/tenant-list/tenant-list.component').then(m => m.TenantListComponent)
            },
            {
                path: 'tenants/:tenantId/secrets',
                loadComponent: () => import('./components/eruai/tenant-variables/tenant-variables.component').then(m => m.TenantSecretsComponent)
            },
            {
                path: 'models',
                loadComponent: () => import('./components/eruai/model-list/model-list.component').then(m => m.ModelListComponent)
            },{
                path: 'models/new',
                loadComponent: () => import('./components/eruai/model-form/model-form.component').then(m => m.ModelFormComponent)
            },
            {
                path: 'models/edit/:model_name',
                loadComponent: () => import('./components/eruai/model-form/model-form.component').then(m => m.ModelFormComponent)
            },
            {
                path: 'tools',
                loadComponent: () => import('./components/eruai/tools-list/tools-list.component').then(m => m.ToolsListComponent)
            },{
                path: 'tools/new',
                loadComponent: () => import('./components/eruai/tool-form/tool-form.component').then(m => m.ToolFormComponent)
            },
            {
                path: 'tools/edit/:tool_name',
                loadComponent: () => import('./components/eruai/tool-form/tool-form.component').then(m => m.ToolFormComponent)
            },{
                path: 'agents',
                loadComponent: () => import('./components/eruai/agents-list/agents-list.component').then(m => m.AgentsListComponent)
            },
            {
                path: 'agents/new',
                loadComponent: () => import('./components/eruai/agent-form/agent-form.component').then(m => m.AgentFormComponent)
            },
            {
                path: 'agents/edit/:agent_name',
                loadComponent: () => import('./components/eruai/agent-form/agent-form.component').then(m => m.AgentFormComponent)
            },{
                path: 'vectors',
                loadComponent: () => import('./components/eruai/vectors-list/vectors-list.component').then(m => m.VectorsListComponent)
            },            {
                path: 'vectors/new',
                loadComponent: () => import('./components/eruai/vector-form/vector-form.component').then(m => m.VectorFormComponent)
            },{
                path: 'vectors/edit/:vector_name',
                loadComponent: () => import('./components/eruai/vector-form/vector-form.component').then(m => m.VectorFormComponent)
            },{
                path: 'vectors/view/:vector_name',
                loadComponent: () => import('./components/eruai/vector-form/vector-form.component').then(m => m.VectorFormComponent)
            },{
                path:'settings',
                loadComponent:()=>import('./components/settings/settings-main/settings-component').then(m=>m.ProjectSettingsComponent)
            },
            {
                path: 'variables',
                loadComponent: () => import('./components/variables/variables.component').then(m => m.VariableComponent)
            }
        ]
    },
    {
        path: 'projects',
        component: AppMainComponent,
        canActivate: [authGuardDeny],
        children: [
            {
                path: '',
                loadComponent: () => import('./components/project/project-main/project-main.component').then(m => m.ProjectMainComponent)
            },
            {
                path: 'list',
                loadComponent: () => import('./components/project/project-list/project-list.component').then(m => m.ProjectListComponent)
            },
            {
                path: 'new',
                loadComponent: () => import('./components/project/project-form/project-form.component').then(m => m.ProjectFormComponent)
            },
            {
                path: 'edit/:project_id',
                loadComponent: () => import('./components/project/project-form/project-form.component').then(m => m.ProjectFormComponent)
            },
            {
                path: 'repository',
                loadComponent: () => import('./components/project/project-repository/project-repository.component').then(m => m.ProjectRepositoryComponent)
            },
            {
                path:'github-callback',
                loadComponent:()=>import('./components/github-callback/github-callback.component').then(m=>m.GitHubCallbackComponent)
            },
        
            {
                path:'import',
                loadComponent:()=>import('./components/import/comparison-view.component').then(m=>m.ComparisonViewComponent)
            },
            {
                path:'users',
                loadComponent:() =>import('./components/project/project-users/project-users.component').then(m=>m.ProjectUsersComponent)
            }
        ]
    },
    {
        path: 'erufiles/:project_id/:env_id',
        component: AppMainComponent,
        canActivate: [authGuardDeny],
        children: [
            {
                path: '',
                loadComponent: () => import('./components/erufiles/erufiles-main/erufiles-main.component').then(m => m.EruFilesMainComponent)
            },
            {
                path: 'storages',
                loadComponent: () => import('./components/erufiles/storage-list/storage-list.component').then(m => m.ErufilesListComponent)
            },
            {
                path: 'storages/new',
                loadComponent: () => import('./components/erufiles/storage-form/storage-form.component').then(m => m.EruStorageComponent)
            },
            {
                path: 'storages/:storage_name',
                loadComponent: () => import('./components/erufiles/storage-form/storage-form.component').then(m => m.EruStorageComponent)
            },
            {
                path: 'keys',
                loadComponent: () => import('./components/erufiles/key-list/key-list.component').then(m => m.ErufilesKeysListComponent)
            },            
            {
                path:'keys/new',
                loadComponent:()=>import('./components/erufiles/key-form/key-form.component').then(m => m.ErufilesKeysComponent)
            },
            {
                path: 'keys/:keyName',
                loadComponent: () => import('./components/erufiles/key-form/key-form.component').then(m => m.ErufilesKeysComponent)
            },
            {
                path:'settings',
                loadComponent:()=>import('./components/settings/settings-main/settings-component').then(m=>m.ProjectSettingsComponent)
            },{
                path:'settings/new-kms',
                loadComponent:()=>import('./components/settings/kms-form/kms-form.component').then(m=>m.KmsFormComponent)

            },
            {
                path: 'settings/edit-kms/:kms_name',
                loadComponent: () => import('./components/settings/kms-form/kms-form.component').then(m => m.KmsFormComponent)
            },
            {
                path: 'variables',
                loadComponent: () => import('./components/variables/variables.component').then(m => m.VariableComponent)
            },
        ]
    },
    {
        path: 'erufunctions/:project_id/:env_id',
        component: AppMainComponent,
        canActivate: [authGuardDeny],
        children: [
            {
                path: '',
                loadComponent: () => import('./components/erufunctions/erufunctions-main/erufunctions-main.component').then(m => m.ErufunctionsMainComponent)
            },
            {
                path: 'list',
                loadComponent: () => import('./components/erufunctions/function-list/function-list.component').then(m => m.ErufunctionsListComponent)
            },{
                path:'settings',
                loadComponent:()=>import('./components/settings/settings-main/settings-component').then(m=>m.ProjectSettingsComponent)
            },
            {
                path:'settings/new-event',
                loadComponent:()=>import('./components/settings/event-form/event-form.component').then(m=>m.EventFormComponent)
            },{
                path:'settings/edit-event/:id',
                loadComponent: () => import('./components/settings/event-form/event-form.component').then(m => m.EventFormComponent)
            },
            {
                path: 'variables',
                loadComponent: () => import('./components/variables/variables.component').then(m => m.VariableComponent)
            },
             {
                  path: 'functions/new',
                  loadComponent: () => import('./components/erufunctions/erufunction-flow/erufunction-flow.component').then(m => m.EruFunctionFlowComponent)
              },
              {
                  path: 'functions/edit/:function_name',
                  loadComponent: () => import('./components/erufunctions/erufunction-flow/erufunction-flow.component').then(m => m.EruFunctionFlowComponent)
              },
             {
                 path: '**',
                 loadComponent: () => import('./components/erufunctions/erufunctions-main/erufunctions-main.component').then(m => m.ErufunctionsMainComponent)
             }
        ]
    },
    {
        path: 'erugateway/:project_id/:env_id',
        component: AppMainComponent,
        canActivate: [authGuardDeny],
        children: [
            {
                path: '',
                loadComponent: () => import('./components/erugateway/erugateway-main/erugateway-main.component').then(m => m.ErugatewayMainComponent)
            },
            {
                path: 'authorizer-list',
                loadComponent: () => import('./components/erugateway/erugateway-list/erugateway-list.component').then(m => m.ErugatewayListComponent)
            },{
                path:'authorizer-list/new',
                loadComponent:()=>import('./components/erugateway/erugateway-authform/erugateway-authform.component').then(m=>m.AuthFormComponent)
            },{
                path:'authorizer-list/:authorizer_name',
                loadComponent:()=>import('./components/erugateway/erugateway-authform/erugateway-authform.component').then(m=>m.AuthFormComponent)
            },
            {
              path: 'rule-list',
              loadComponent: () => import('./components/erugateway/erugateway-rule-list/erugateway-rulelist.component').then(m => m.ErugatewayRuleListComponent)
            },
            {
                path:'rule-list/new',
                loadComponent: () => import('./components/erugateway/erugateway-list-form/erugateway-list-form').then(m=>m.RuleFormComponent)
            },{
                path:'rule-list/:rule_name',
                loadComponent: () => import('./components/erugateway/erugateway-list-form/erugateway-list-form').then(m=>m.RuleFormComponent)
            },{
                path:'settings',
                loadComponent:()=>import('./components/settings/settings-main/settings-component').then(m=>m.ProjectSettingsComponent)
        
            },
            // {
            //     path: '**',
            //     loadComponent: () => import('./components/erugateway/erugateway-main/erugateway-main.component').then(m => m.ErugatewayMainComponent)
            // },
        ]
    },
    {
        path: 'eruql/:project_id/:env_id',
        component: AppMainComponent,
        canActivate: [authGuardDeny],
        children: [
            {
                path: '',
                loadComponent: () => import('./components/eruql/eruql-main/eruql-main.component').then(m => m.EruqlMainComponent)
            },
            {
                path: 'database',
                loadComponent: () => import('./components/eruql/database-list/database-list.component').then(m => m.EruqlDatabaseComponent)
            },
            {
                path: 'database/new',
                loadComponent: () => import('./components/eruql/eruql-add-db/eruql-add-db.component').then(m => m.EruqlAddDbComponent )
            },
            {
                path: 'database/new/custom-rule',
                loadComponent: () => import('./components/eruql/custom-rules/custom-rule.component').then(m => m.CustomRuleComponent)
            },
            {
                path: 'database/edit/:db_alias',
                loadComponent: () => import('./components/eruql/eruql-add-db/eruql-add-db.component').then(m => m.EruqlAddDbComponent )
            },
            {
                path: 'database/:db_alias',
                loadComponent: () => import('./components/eruql/db-details/eruql-db-details.component').then(m => m.DbDetailComponent)
            },
            {
                path: 'database/:db_alias/create-table',
                loadComponent: () => import('./components/eruql/create-table/create-table.component').then(m => m.CreateTableComponent)
            },
            {
                path: 'database/:db_alias/custom-rule',
                loadComponent: () => import('./components/eruql/custom-rules/custom-rule.component').then(m => m.CustomRuleComponent)
            },
            {
                path: 'myqueries',
                loadComponent: () => import('./components/eruql/myquery-list/myquery-list.component').then(m => m.EruqlMyqueriesComponent )
            },
            {
                path: 'myqueries/new',
                loadComponent: () => import('./components/eruql/myquery-form/myquery-form.component').then(m => m.QueryListComponent )
            },
            {
                path: 'myqueries/edit/:query_name',
                loadComponent: () => import('./components/eruql/myquery-form/myquery-form.component').then(m => m.QueryListComponent )
            },
            {
                path:'settings',
                loadComponent:()=>import('./components/settings/settings-main/settings-component').then(m=>m.ProjectSettingsComponent)
            },
            {
                path: 'settings/edit-kms/:kms_name',
                loadComponent: () => import('./components/settings/kms-form/kms-form.component').then(m => m.KmsFormComponent)
            },
            {
              path: 'variables',
              loadComponent: () => import('./components/variables/variables.component').then(m => m.VariableComponent)
            },
            // {
            //     path: '**',
            //     loadComponent: () => import('./components/eruql/eruql-main/eruql-main.component').then(m => m.EruqlMainComponent)
            // },
        ]
    }
];